/**
 * WidgetTypes corresponding to Backends SonWidgetType.
 */
export enum WidgetType {
  custompersonalmessages = 'custompersonalmessages',
  editorialMessages = 'editorialMessages',
  teamroommessages = 'teamroommessages',
  recommendationmessages = 'recommendationmessages',
  filecategories = 'filecategories',
  pagetypecategories = 'pagetypecategories',
  announcementcategories = 'announcementcategories',
  pagesettings = 'pagesettings',
  pagetypevalidityperiod = 'pagetypevalidityperiod',
  favoritedpages = 'favoritedpages',
  favoritedusers = 'favoritedusers',
  mostpopularpages = 'mostpopularpages',
  personalsettings = 'personalsettings',
  watchedpagemessagesblock = 'watchedpagemessagesblock',
  useranonymous = 'useranonymous',
  useraccount = 'useraccount',
  applibrary = 'applibrary',
  applibraryglobal = 'applibraryglobal',
  applibrarypersonal = 'applibrarypersonal',
  comments = 'comments',
  editorFeedback = 'editorfeedback',
  attachedfiles = 'attachedfiles',
  connectedUsers = 'connectedUsers',
  pageToPage = 'pageToPage',
  structuralPageToPage = 'structuralPageToPage',
  structuralPageToPageTree = 'structuralPageToPageTree',
  orgunitMemberships = 'orgunitMemberships',
  locationMemberships = 'locationMemberships',
  processMemberships = 'processMemberships',
  topicMemberships = 'topicMemberships',
  blogauthors = 'blogauthors',
  blogpostsiblings = 'blogpostsiblings',
  latestadditions = 'latestadditions',
  upcomingevents = 'upcomingevents',
  currentannouncementsinbox = 'currentannouncementsinbox',
  currentannouncementsoutbox = 'currentannouncementsoutbox',
  currentmandatoryannouncementsforpage = 'currentmandatoryannouncementsforpage',
  externallinks = 'externallinks',
  userexternallinks = 'userexternallinks',
  latestforumposts = 'latestforumposts',
  calendar = 'calendar',
  contactpersons = 'contactpersons',
  personprofileedithint = 'personprofileedithint',
  portalsettingimportexport = 'portalsettingimportexport',
  teamroommemberrequestslist = 'teamroommemberrequestslist',
  areagroups = 'areagroups',
  genericsearchlist = 'genericsearchlist',
  personextendeddata = 'personextendeddata',
  userinfo = 'userinfo',
  attributegroupinfo = 'attributegroupinfo',
  attributegrouppersons = 'attributegrouppersons',
  attributegroupactivity = 'attributegroupactivity',
  blogpostlist = 'blogpostlist',
  rolesettings = 'rolesettings',
  topvideo = 'topvideo',
  topheadlines = 'topheadlines',
  rssfeed = 'rssFeed',
  contentsearchstatistics = 'contentsearchstatistics',
  systempagestatistics = 'systempagestatistics',
  privilegedgroups = 'privilegedgroups',
  pagemembershipmatchingattributes = 'pagemembershipmatchingattributes',
  pagemembershipmatchingrulesettings = 'pagemembershipmatchingrulesettings',
  pagetrash = 'pagetrash',
  latestregistrations = 'latestRegistrations',
  accesslevel = 'ext_fibAccessLevel',
  pendingAccessLevelRequests = 'ext_fibPendingAccessLevelRequests',
  pagetyperoles = 'pagetyperoles',
  gvpprint = 'gvpPrint',
  userimportconfigurationwidget = 'userimportconfigurationwidget',
}

/**
 * BlockTypes corresponding to Backends SonBlockType.
 */

export enum BlockType {
  applibrary = 'applibrary',
  applibraryPersonal = 'applibraryPersonal',
  applibraryPersonalFetch = 'applibraryPersonalFetch',
  attachedfiles = 'attachedfiles',
  blogauthors = 'blogauthors',
  blogpostsiblings = 'blogpostsiblings',
  blogpostlist = 'blogpostlist',
  cspFrameSourceConfig = 'cspFrameSourceConfig',
  allowedmimetypes = 'allowedmimetypes',
  navigationproperties = 'navigationproperties',
  portaltitle = 'portaltitle',
  changepasswordurl = 'changepasswordurl',
  supportEmail = 'supportEmail',
  newsletterfooter = 'newsletterfooter',
  registrationEmail = 'registrationemail',
  registrationvalidity = 'registrationvalidity',
  personProfileEditHintConfig = 'personprofileedithintconfig',
  personalDataProcessingText = 'personaldataprocessingtext',
  portalInformationLink = 'portalInformationLink',
  goliveMode_enabled = 'goliveMode_enabled',
  goliveMode_userGroupId = 'goliveMode_userGroupId',
  anonymousaccess_enabled = 'anonymousaccess_enabled',
  userregistration_enabled = 'userregistration_enabled',
  inviteunregistered_enabled = 'inviteunregistered_enabled',
  portaluserregistration_enabled = 'portaluserregistration_enabled',
  sessionrestrictor_enabled = 'sessionRestrictor_enabled',
  highestConfidentialLevel = 'highestConfidentialLevel',
  defaultConfidentialLevel = 'defaultConfidentialLevel',
  printingDependsOnConfidentialLevels = 'printingDependsOnConfidentialLevels',
  extendedProtocol_readAccess_enabled = 'extendedProtocol_readAccess_enabled',
  extendedProtocol_writeAccess_adminContent_enabled = 'extendedProtocol_writeAccess_adminContent_enabled',
  extendedProtocol_writeAccess_userContent_enabled = 'extendedProtocol_writeAccess_userContent_enabled',
  userregistrationpresets = 'userregistrationpresets',
  configurationaggregate = 'configurationaggregate',
  compositionconfiguration = 'compositionconfiguration',
  pluginconfiguration = 'pluginconfiguration',
  defaultForMembersWithParentTask = 'defaultForMembersWithParentTask',
  defaultForMembersWithParentTeamroom = 'defaultForMembersWithParentTeamroom',
  defaultForMembersWithParentTopic = 'defaultForMembersWithParentTopic',
  defaultForMembersWithParentOrgunit = 'defaultForMembersWithParentOrgunit',
  defaultForMembersWithParentLocation = 'defaultForMembersWithParentLocation',
  defaultForMembersWithParentProcess = 'defaultForMembersWithParentProcess',
  defaultForNewsletterFrequency = 'defaultForNewsletterFrequency',
  filecategories = 'filecategories',
  pagetypeslist = 'pagetypeslist',
  pagetypepagelead = 'pagetypepagelead',
  pagetypecategories = 'pagetypecategories',
  announcementcategories = 'announcementcategories',
  pagetypevalidityperiod = 'pagetypevalidityperiod',
  pageLockValidityPeriod = 'pageLockValidityPeriod',
  depublishPagesWithExceededValidityPeriod_enabled = 'depublishPagesWithExceededValidityPeriod_enabled',
  userImportSystemService_enabled = 'userImportSystemService_enabled',
  pageMembershipMatcherSystemService_enabled = 'pageMembershipMatcherSystemService_enabled',
  deviatingvalidityperiods = 'deviatingvalidityperiods',
  imagegallery = 'imagegallery',
  pagelistdetails = 'pagelistdetails',
  pagelayout = 'pagelayout',
  pagepropertysettings = 'pagepropertysettings',
  pagereadrestrictions = 'pagereadrestrictions',
  useraccount = 'useraccount',
  useranonymous = 'useranonymous',
  accesskeyssettings = 'accesskeyssettings',
  favoritedpages = 'favoritedpages',
  favoritedusers = 'favoritedusers',
  mostpopularpages = 'mostpopularpages',
  newslettersettings = 'newslettersettings',
  colorschemesettings = 'colorschemesettings',
  personalmessages = 'personalmessages',
  watchedpagemessagesblock = 'watchedpagemessagesblock',
  footer = 'footer',
  institutiondisplay = 'institutiondisplay',
  breadcrumb = 'breadcrumb',
  instantsearch = 'instantsearch',
  loginLogout = 'loginLogout',
  mainnavigation = 'mainnavigation',
  pagemanagement = 'pagemanagement',
  pagemetainfo = 'pagemetainfo',
  timecontrolledpublicationinfo = 'timecontrolledpublicationinfo',
  proposedpagepublicationinfo = 'proposedpagepublicationinfo',
  pagevalidityexpiredinfo = 'pagevalidityexpiredinfo',
  pageArchivedInfo = 'pagearchivedinfo',
  comments = 'comments',
  editorFeedback = 'editorfeedback',
  thread = 'thread',
  threadlist = 'threadlist',
  topheadlines = 'topheadlines',
  topheadlinesarchive = 'topheadlinesarchive',
  backtoparent = 'backtoparent',
  logindescription = 'logindescription',
  richtext = 'richtext',
  on2content = 'on2content',
  connectedUsers = 'connectedUsers',
  pageToPage = 'pageToPage',
  structuralPageToPage = 'structuralPageToPage',
  personinteraction = 'personinteraction',
  externalUserRegistration = 'externaluserregistration',
  orgunitMemberships = 'orgunitMemberships',
  locationMemberships = 'locationMemberships',
  processMemberships = 'processMemberships',
  topicMemberships = 'topicMemberships',
  childpagestree = 'childpagestree',
  structuralPageToPageTree = 'structuralPageToPageTree',
  keywordindex = 'keywordindex',
  latestadditions = 'latestadditions',
  upcomingevents = 'upcomingevents',
  teaserinformation = 'teaserinformation',
  transformpagetype = 'transformpagetype',

  allannouncementsinbox = 'allannouncementsinbox',
  allannouncementsoutbox = 'allannouncementsoutbox',
  currentannouncementsinbox = 'currentannouncementsinbox',
  currentannouncementsoutbox = 'currentannouncementsoutbox',
  currentmandatoryannouncementsforpage = 'currentmandatoryannouncementsforpage',
  externallinks = 'externallinks',
  userexternallinks = 'userexternallinks',
  externalcontent = 'externalcontent',
  pdffiledetails = 'pdffiledetails',
  latestforumposts = 'latestforumposts',
  calendar = 'calendar',
  contactpersons = 'contactpersons',
  personprofileedithint = 'personprofileedithint',
  teamroommemberrequestslist = 'teamroommemberrequestslist',
  usertopageroleslist = 'usertopageroleslist',
  usertouserroleslist = 'usertouserroleslist',
  usertopagerolepagelead = 'usertopagerolepagelead',
  usertouserrolepagelead = 'usertouserrolepagelead',
  rolespecificareagroups = 'rolespecificareagroups',
  overallareagroups = 'overallareagroups',
  genericsearchlist = 'genericsearchlist',
  personextendeddata = 'personextendeddata',
  personcontactdata = 'personcontactdata',
  personaffiliation = 'personaffiliation',
  personadditionalinformation = 'personadditionalinformation',
  personvcard = 'personvcard',
  pagetemplate = 'pagetemplate',
  userpagelead = 'userpagelead',
  childPageMetaInfo = 'childPageMetaInfo',

  profileimage = 'profileimage',
  portalavatar = 'portalavatar',
  portallogo = 'portallogo',
  titleimage = 'titleimage',
  contentimage = 'contentimage',

  pagestatistics = 'pagestatistics',
  childpages = 'childpages',
  tableofcontents = 'tableofcontents',

  eventicaldownload = 'eventicaldownload',
  pageinstantreaction = 'pageinstantreaction',
  eventparticipation = 'eventparticipation',
  personcollection = 'personcollection',
  systempagestatistics = 'systempagestatistics',
  contentsearchstatistics = 'contentsearchstatistics',
  searchstatistics = 'searchstatistics',
  attributegroupslist = 'attributegroupslist',
  attributegroupinfo = 'attributegroupinfo',
  attributegroupproperties = 'attributegroupproperties',
  attributegrouppersons = 'attributegrouppersons',
  attributegroupactivity = 'attributegroupactivity',
  pagelead = 'pagelead',
  accesskeys = 'accesskeys',
  error = 'error',
  attributegrouppagelead = 'attributegrouppagelead',
  rolesettings = 'rolesettings',
  rolevalidforpagetypesettings = 'rolevalidforpagetypesettings',
  roledefaultforpagetypesettings = 'roledefaultforpagetypesettings',
  video = 'video',
  areamembers = 'areamembers',
  teamroommemberrequests = 'teamroommemberrequests',
  teamroommanagement = 'teamroommanagement',
  layoutgroup = 'layoutgroup',
  survey = 'survey',
  ticketbooking = 'ticketbooking',
  sharedfiles = 'sharedfiles',
  eventlistdetails = 'eventlistdetails',
  faqlist = 'faqlist',
  usersearch = 'usersearch',
  contentsearch = 'contentsearch',
  editorialdashboard = 'editorialdashboard',
  rssfeed = 'rssFeed',
  portalThemeHighlightColor = 'portalthemehighlightcolor',
  maxFileSizeConfig = 'maxFileSizeConfig',
  basicprivilegeconfig = 'basicprivilegeconfig',
  additionalprivilegeconfig = 'additionalprivilegeconfig',
  roleprivilegeconfig = 'roleprivilegeconfig',
  privilegedgroups = 'privilegedgroups',
  pagemembershipmatchingattributes = 'pagemembershipmatchingattributes',
  pagemembershipmatchingrulelist = 'pagemembershipmatchingrulelist',
  pagemembershipmatchingrulesettings = 'pagemembershipmatchingrulesettings',
  pagemembershipmatchingrulepagelead = 'pagemembershipmatchingrulepagelead',
  pagemembershipmatchingrulereports = 'pagemembershipmatchingrulereports',
  pagetrash = 'pagetrash',
  formapplication = 'formapplication',
  formapplicationSettings = 'formapplicationSettings',
  latestRegistrations = 'latestRegistrations',
  currentAccessLevel = 'ext_fibCurrentAccessLevel',
  changeAccessLevel = 'ext_fibChangeAccessLevel',
  pendingaccesslevelrequests = 'ext_fibPendingAccessLevelRequests',
  changeEmailAddress = 'changeEmailAddress',
  collapsiblecontainer = 'collapsibleContainer',
  pagetyperoles = 'pagetyperoles',
  executiveorganisationchartprint = 'gvpPrint',
  userimportconfiguration = 'userimportconfiguration',
  usersourceslist = 'usersourceslist',
  userimportreports = 'userimportreports',
}

/**
 *  @Deprecated Please use either Widget- or BlockType
 */
export enum ElementType {
  portaladministration = 'portaladministration',
  systemadministration = 'systemadministration',
  passwordforgotform = 'passwordforgotform',
  passwordresetform = 'passwordresetform',
  content = 'content',
  attachedfiles = 'attachedfiles',
  eventdetails = 'eventDetails',
  externallink = 'externallink',
  externallinkdetails = 'externallinkdetails',
  externalcontent = 'externalcontent',
  favoritedpages = 'favoritedpages',
  favoritedusers = 'favoritedusers',
  newslettersettings = 'newslettersettings',
  accesskeyssettings = 'accesskeyssettings',
  colorschemesettings = 'colorschemesettings',
  pagesettings = 'pagesettings',
  usermemberships = 'usermemberships',
  topheadlines = 'topheadlines',
  personalmessages = 'personalmessages',
  watchedpagemessagesblock = 'watchedpagemessagesblock',
  teamroommanagement = 'teamroommanagement',
  userregistration = 'userregistration',
  userregistrationform = 'userregistrationform',
  helprichtext = 'helprichtext',

  searchlist = 'searchlist',
  contentWrapper = 'contentWrapper',
  executiveorganisationchartprint = 'gvpPrint',
}
